import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { Link } from "gatsby"

class Ca extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111;
            padding: 100px 0 30px 0;
            .heading {
                width: 100%;
            }                    
        `

        const ServiceRow = styled(Row)`
            margin-top: 150px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;
            
            &:hover {
                color: #0174c3 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `
        const ServiceHeading3 = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;            
            &:hover {
                color: #e44100 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const ServiceHeading3r = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;            
            &:hover {
                color: #74cd71 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const ServiceHeading3t = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;            
            &:hover {
                color: #de242e !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const ServiceHeading3s = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;            
            &:hover {
                color: #00b373 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const ServiceHeading3v = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;            
            &:hover {
                color: #c1eb18 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const Heading2 = styled.h2`
            font-size: 40px;
            line-height: 50px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            margin: 10px 0;
            @media (max-width: 767px) {
                margin: 50px 0 20px 0;
                font-size: 30px;
                line-height: 40px;           
            }
        `
        const Heading2c = styled.h2`
            font-size: 40px;
            line-height: 50px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            margin: 40px 0 0 0;
            @media (max-width: 767px) {
                margin: 50px 0 20px 0;
                font-size: 30px;
                line-height: 40px;           
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 5px;
        `

        const ServiceSeparatorw = styled.div`
            height: 2px;
            width: 50px;
            background-color: #0174c3;
            margin-bottom: 5px;
        `

        const ServiceSeparatorr = styled.div`
            height: 2px;
            width: 50px;
            background-color: #74cd71;
            margin-bottom: 5px;
        `

        const ServiceSeparatorp = styled.div`
            height: 2px;
            width: 50px;
            background-color: #e44100;
            margin-bottom: 5px;
        `

        const ServiceSeparatort = styled.div`
            height: 2px;
            width: 50px;
            background-color: #de242e;
            margin-bottom: 5px;
        `

        const ServiceSeparators = styled.div`
            height: 2px;
            width: 50px;
            background-color: #00b373;
            margin-bottom: 5px;
        `

        const ServiceNumber = styled.p`
            position: absolute;
            font-size: 60px;
            color: #fff;
            font-weight: 900;
            top: -80px;
            opacity: .2;
            margin-bottom: 20px;
            transition: .2s;
        `

        const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .4 !important;
                color: #fff;
            }
        `

        const ServiceText = styled.p`
            font-size: 17px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #fff;            
        `

        const Color = styled.span`            
            color: #0174c3;            
        `

        const Color1 = styled.span`            
            color: #e44100;            
        `

        const Color2 = styled.span`            
            color: #74cd71;            
        `

        const Color3 = styled.span`            
            color: #de242e;            
        `

        const Color4 = styled.span`            
            color: #00b373;            
        `

        const Color5 = styled.span`            
            color: #c1eb18;
            font-size: 50px;            
        `

        const Colorv = styled.span`
            font-weight: bold;            
            color: #C1EB18;            
        `

        const Colorvasco = styled.span`            
            color: #C1EB18;
            font-family: Oswald;            
        `

        const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #fff;
            padding-right: 25px;        
        `

        const Span = styled.span`
            font-size: 20px;
            font-weight: 300;
            color: #fff;            
        `
        const Color6 = styled.span`          
          color: #3dcd2b;
          font-family: "Teko", sans-serif;            
        `

        const Heading2b = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin-top: 100px;            
            font-size: 60px;
            line-height: 70px;
            font-family: "Teko", sans-serif;
            font-weight: 500;
            color: #fff;
            text-align: center;
        `

        const { data } = this.props;
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }

        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)


        return (
            <Section id='CA'>
                <Container>
                    <Heading2b>Comprar Certificado <Color6>SSL</Color6></Heading2b>
                    <Heading2b>Marcas (CA) Líderes en <Color6>Certificados SSL</Color6></Heading2b>
                    <Heading2>
                        Autoridades de Certificación (CA): Seguridad y Confianza
                    </Heading2>
                    <Text>
                        Los certificados SSL de marcas reconocidas como DigiCert, GeoTrust, RapidSSL, Sectigo, y Thawte son emitidos por Autoridades de Certificación (CA) internacionales
                        que garantizan la legitimidad y seguridad de tu sitio, app o plataforma. Ideales para empresas en Bogotá, Medellín, y Barranquilla que buscan confianza y
                        profesionalismo en línea.
                    </Text>
                    <Heading2c>
                        SSL en Colombia: Tu Socio en Seguridad
                    </Heading2c>
                    <Text>
                        Obtener un Certificado SSL en Colombia, es realmente muy fácil, facilitamos la protección de tus proyectos en Bogotá, Medellín, Barranquilla, Pereira, Cali,
                        Bucaramanga, y Cartagena con certificados SSL de marcas líderes. Como distribuidores autorizados, ofrecemos soluciones confiables y soporte local.
                    </Text>
                    <Heading2c>
                        <Colorvasco>VASCO</Colorvasco> Solutions: Distribuidores autorizados
                    </Heading2c>
                    <Text>
                        VASCO Solutions es distribuidor directo de DigiCert, GeoTrust, Thawte, RapidSSL, y Sectigo. Nuestra experiencia y compromiso garantizan certificados SSL de
                        calidad para pymes, desarrolladores, entidades del estado y corporaciones en Colombia, con precios bajos.
                    </Text>
                    <ServiceRow>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color1>GeoTrust</Color1>
                                </ServiceNumber>
                                <ServiceHeading3>
                                    <Link to="/ssl-geotrust">GeoTrust</Link>
                                </ServiceHeading3>
                                <ServiceSeparatorp />
                                <ServiceText>
                                    GeoTrust, una marca confiable en el mundo de la seguridad digital, ofrece soluciones de certificados SSL/TLS que proporcionan protección
                                    y tranquilidad a empresas de todos los tamaños. Como distribuidores autorizados de GeoTrust, estamos comprometidos a proporcionar a
                                    nuestros clientes certificados SSL/TLS confiables y efectivos que ayuden a proteger su negocio en línea y a construir la confianza de sus clientes.
                                    Líder en seguridad para plataformas en Medellín.
                                </ServiceText>
                                <ServicePrecio>
                                    Desde ${prices.find(x => x.name === 'geo').price}<Span>/año</Span>
                                </ServicePrecio>
                                <ServiceText>
                                    <Colorv>Tecnología SSL Flex DISPONIBLE</Colorv>
                                </ServiceText>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color>DigiCert</Color>
                                </ServiceNumber>
                                <ServiceHeading>
                                    <Link to="/ssl-digicert">DigiCert</Link>
                                </ServiceHeading>
                                <ServiceSeparatorw />
                                <ServiceText>
                                    DigiCert es una autoridad de certificación líder en el mundo, reconocida por su compromiso con
                                    la seguridad y la innovación tecnológica. Como distribuidores directos y socios autorizados
                                    de DigiCert, tenemos el privilegio de ofrecer a nuestros clientes una amplia gama de soluciones
                                    de seguridad digital, incluidos los certificados SSL/TLS de primera calidad que garantizan
                                    la protección de sus datos en línea. Seguridad confiable para empresas en Bogotá.
                                </ServiceText>
                                <ServicePrecio>
                                    Desde ${prices.find(x => x.name === 'digi').price}<Span>/año</Span>
                                </ServicePrecio>
                                <ServiceText>
                                    <Colorv>Tecnología SSL Flex DISPONIBLE</Colorv>
                                </ServiceText>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color2>RapidSSL</Color2>
                                </ServiceNumber>
                                <ServiceHeading3r>
                                    <Link to="/rapidssl">RapidSSL</Link>
                                </ServiceHeading3r>
                                <ServiceSeparatorr />
                                <ServiceText>
                                    RapidSSL es conocida por ofrecer certificados SSL de alta calidad a precios asequibles, lo que
                                    la convierte en una opción popular para sitios web de todo tipo. Como distribuidores autorizados
                                    de RapidSSL, tenemos el privilegio de ofrecer a nuestros clientes soluciones de seguridad
                                    digital confiables y efectivas que garantizan la protección de sus datos en línea sin
                                    comprometer su presupuesto. Certificados económicos para sitios en Barranquilla.
                                </ServiceText>
                                <ServicePrecio>
                                    Desde ${prices.find(x => x.name === 'rapid').price}<Span>/año</Span>
                                </ServicePrecio>
                            </ServiceElement>

                        </Col>
                    </ServiceRow>
                    <ServiceRow>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color3>Thawte</Color3>
                                </ServiceNumber>
                                <ServiceHeading3t>
                                    <Link to="/ssl-thawte">Thawte</Link>
                                </ServiceHeading3t>
                                <ServiceSeparatort />
                                <ServiceText>
                                    Thawte es una autoridad de certificación de renombre mundial, reconocida por su enfoque
                                    en la seguridad y la confianza en línea. Como distribuidores autorizados de Thawte,
                                    estamos comprometidos a proporcionar a nuestros clientes certificados SSL/TLS de
                                    primera calidad que les brinden la tranquilidad y la seguridad que necesitan para
                                    llevar a cabo sus operaciones en línea de manera segura y confiable. Soluciones premium
                                    para pymes en Pereira.
                                </ServiceText>
                                <ServicePrecio>
                                    Desde ${prices.find(x => x.name === 'thaw').price}<Span>/año</Span>
                                </ServicePrecio>
                                <ServiceText>
                                    <Colorv>Tecnología SSL Flex DISPONIBLE</Colorv>
                                </ServiceText>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color4>Sectigo</Color4>
                                </ServiceNumber>
                                <ServiceHeading3s>
                                    <Link to="/ssl-sectigo">Sectigo</Link>
                                </ServiceHeading3s>
                                <ServiceSeparators />
                                <ServiceText>
                                    Sectigo, anteriormente conocida como Comodo CA, es una de las autoridades de certificación más
                                    grandes del mundo, reconocida por su enfoque en la innovación y la seguridad en línea. Como
                                    distribuidores autorizados de Sectigo, tenemos acceso a una amplia gama de soluciones de
                                    seguridad digital, incluidos los certificados SSL/TLS de alta calidad que ayudan a proteger
                                    la privacidad y la integridad de los datos en línea de nuestros clientes. Certificados asequibles
                                    para apps en Cali.
                                </ServiceText>
                                <ServicePrecio>
                                    Desde ${prices.find(x => x.name === 'sect').price}<Span>/año</Span>
                                </ServicePrecio>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color5>Powered by</Color5>
                                </ServiceNumber>
                                <ServiceHeading3v>
                                    <Link to="/ssl-vasco">SSL</Link>
                                </ServiceHeading3v>
                                <ServiceSeparator />
                                <ServiceText>
                                    Nuestros clientes pueden beneficiarse de certificados SSL/TLS de alta calidad que cumplen con
                                    los estándares de seguridad más estrictos de la industria. Ya sea que necesiten un certificado
                                    para un solo dominio, múltiples dominios o subdominios ilimitados, SSL ofrece opciones flexibles
                                    que se adaptan a las necesidades específicas de cada negocio. Soluciones flexibles para proyectos
                                    en Bucaramanga.
                                </ServiceText>
                                <ServicePrecio>
                                    Desde ${prices.find(x => x.name === 'vasco').price}<Span>/año</Span>
                                </ServicePrecio>
                                <ServiceText>
                                    <Colorv>Tecnología SSL Flex DISPONIBLE</Colorv>
                                </ServiceText>
                            </ServiceElement>

                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }

}

export const query = graphql`
  query {
    allPricesJson(filter: { page: { eq: "CA" }, section: { eq: "planes" } }) {
      nodes {
        items {
          name
          price
        }
      }
    }
  }
`

const Ssl = (props) => (
    <StaticQuery
        query={query}
        render={(data) => (
            <Ca
                data={data}
            />
        )}
    />
)
export default Ssl;